var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_c('b-card-header'),(_vm.dadosCobranca)?_c('b-card-body',[_c('chartjs-component-bar-chart',{attrs:{"height":400,"data":_vm.latestBarChart.data,"options":_vm.latestBarChart.options}})],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }